import { render, staticRenderFns } from "./CurrencySign.vue?vue&type=template&id=2df8515c&"
import script from "./CurrencySign.vue?vue&type=script&lang=js&"
export * from "./CurrencySign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports